export default __webpack_public_path__ + "static/media/05-alt.353549ba.png";